import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import templates from "../../utils/templates";
import TitleBehavior from "../../behaviors/title";
import ReportLegend from "../../behaviors/report-legend";
import DataTable from "../datatable/report";
import mix from "../../utils/mixin-builder";
import DTConfigMixin from "../../mixins/datatable/configuration";
import DTButtonsMixin from "../../mixins/datatable/buttons";

const globalChannel = Radio.channel("global");
const reportChannel = Radio.channel("report");

const DEFAULTS = {
  template: templates.find("layout", "report_container_main_screen"),
};

class View extends mix(Marionette.LayoutView).with(
  DTConfigMixin,
  DTButtonsMixin
) {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  regions() {
    return {
      legend: ".report-legend",
      report: ".table-container",
    };
  }

  behaviors() {
    return [{ behaviorClass: TitleBehavior }, { behaviorClass: ReportLegend }];
  }

  initialize() {
    // defaults
    this.configReadyEvent = "config-ready";
    this.filtersUpdatedEvent = "filters-updated";
    this.afterAjaxEvent = "after-ajax";
    this.reportingPreferencesUpdatedEvent = `${this.model.getRoute()}.reporting-preferences-updated`;
    this.reportingPreferencesReorderedEvent = `${this.model.getRoute()}.report-columns-reordered`;

    // LISTENERS

    // used by config mixin
    this.listenTo(
      reportChannel,
      this.filtersUpdatedEvent,
      this._onFiltersUpdated
    );
    this.listenTo(globalChannel, "customize-view", this._customizeView);
    this.listenTo(reportChannel, this.configReadyEvent, this._renderReport);
    this.listenTo(
      reportChannel,
      this.reportingPreferencesUpdatedEvent,
      this._onReportingPreferencesUpdate
    );
    this.listenTo(
      reportChannel,
      this.reportingPreferencesReorderedEvent,
      this._onReportColumnsReordered
    );

    // used by mixins and custom events
    this.listenTo(reportChannel, this.afterAjaxEvent, this._onAfterAjax);

    this.listenTo(globalChannel, "error", this._onError);
    this.listenTo(reportChannel, "error", this._onError);

    // this._setupReport();
  }

  _onAfterAjax(data) {
    // call mixin method
    this.addButtons(data);

    // fire custom event
    this.triggerMethod("ReportLegend", data.model.getMeta().getLegend());
  }

  _setupReport() {
    // reset report region and get new configuration
    this.report.reset();
  }

  _renderReport(config) {
    // console.info("_renderReport::config", config);
    // localize report config options
    this.reportConfig = config;

    // set the table's ID to the route name
    // in order to save a unique state.
    this.reportConfig.id = config.route;

    // inject after ajax event name
    this.reportConfig.afterAjaxEvent = this.afterAjaxEvent;

    // used to calculate DT height
    this.reportConfig.isDrilldown = false;

    // render report view
    this.report.show(new DataTable(this.reportConfig));
  }

  _onError(message) {
    globalChannel.trigger("status:show", {
      type: "danger",
      message,
    });
  }
}

export { View as default };
